export default {
    topics: [
        {
            title: ' SoapService ',
            href: 'm-SoapService-SoapService.html',
            attributes: { 'data-id': 'm-SoapService-SoapService' },
            menu: { hasChildren: false },
            tocID: 'm-SoapService-SoapService-d66e5578',
            topics: [],
        },
        {
            title: ' addMethod ',
            href: 'm-SoapService-addMethod.html',
            attributes: { 'data-id': 'm-SoapService-addMethod' },
            menu: { hasChildren: false },
            tocID: 'm-SoapService-addMethod-d66e5586',
            topics: [],
        },
        {
            title: ' complete ',
            href: 'p-SoapService-complete.html',
            attributes: { 'data-id': 'p-SoapService-complete' },
            menu: { hasChildren: false },
            tocID: 'p-SoapService-complete-d66e5594',
            topics: [],
        },
        {
            title: ' dispose ',
            href: 'm-SoapService-dispose.html',
            attributes: { 'data-id': 'm-SoapService-dispose' },
            menu: { hasChildren: false },
            tocID: 'm-SoapService-dispose-d66e5602',
            topics: [],
        },
        {
            title: ' header ',
            href: 'p-SoapService-header.html',
            attributes: { 'data-id': 'p-SoapService-header' },
            menu: { hasChildren: false },
            tocID: 'p-SoapService-header-d66e5610',
            topics: [],
        },
        {
            title: ' start ',
            href: 'm-SoapService-start.html',
            attributes: { 'data-id': 'm-SoapService-start' },
            menu: { hasChildren: false },
            tocID: 'm-SoapService-start-d66e5618',
            topics: [],
        },
        {
            title: ' timeout ',
            href: 'p-SoapService-timeout.html',
            attributes: { 'data-id': 'p-SoapService-timeout' },
            menu: { hasChildren: false },
            tocID: 'p-SoapService-timeout-d66e5626',
            topics: [],
        },
        {
            title: ' wait ',
            href: 'm-SoapService-wait.html',
            attributes: { 'data-id': 'm-SoapService-wait' },
            menu: { hasChildren: false },
            tocID: 'm-SoapService-wait-d66e5634',
            topics: [],
        },
    ],
};

